import React from 'react'
import { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Principal from './Principal';
import Principal2 from './Principal2';
import Principal3 from './Principal3';
import '../About/About.css';
import Logop from './Logop';
import Tecnologias from './Tecnologias';
import Servicios from './Servicios';
import Proyectosr from './Proyectosr';
import Contactop from './Contactop';
import Footer from '../Footer/Footer';
import { TypeAnimation } from 'react-type-animation';
const About = () => {
  


  return (
    <>
    <div className='separador'>
    <h3 className='colorini titulo-servicio' id='tamaño-fuente'><TypeAnimation
              sequence={[

                "Construyendo tu presencia digital desde cero.",500,
                "Innovación a medida, potenciando tu presencia online.",500,
                "Construimos la web de tus sueños.",500,
                "Diseño web personalizado para tu éxito online.",500,
                "No dudes en contactarnos."
              ]} 
              repeat={0}
              /* style={{ fontSize: '1.5em' }} */
            /></h3>
    </div>
    
      
    <Container fluid>
      <Logop/> {/* Logo y slogan */} 
      <br></br>
      <Col className='principal-form ' ><Principal/></Col> {/* Aca iria div con introduccion y lo que hacemos */}
      
     {/*  <div className='separador-1'></div>
      */}
      <Col className='principal-servform' ><Servicios/></Col> {/* Aca iria div con servicios */}
      <Col className='principal-tecform' ><Tecnologias/></Col> {/* Aca iria div con tecnologias que usamos */}
      <Col className='principal-projform'  ><Proyectosr/></Col> {/* Aca iria div con proyectos realizados*/}
      <Col className='principal-form1'><Contactop/></Col> {/* Aca iria div de contacto */} 
    </Container>
   
      <div className='separador-f'>
        <Footer/>
        </div>        
  </>
  )
}

export default About